import OkC from "shared/util/OkcApi";

import {
	SECTIONS,
	USERS_TO_FETCH,
} from "apps/discovery/util/consts";

export default {
	getSections() {
		return OkC.post("/discovery", {
			data: {
				prepopulated_section_count: 2,
			},
		});
	},

	getSection(section) {
		return OkC.post("/discovery/section", {
			data: {
				section,
				limit: USERS_TO_FETCH[section] || 20,
			},
		});
	},

	searchInterest(q) {
		return OkC.get("/interests/query", {
			data: {
				q,
			},
		});
	},

	searchQuestion(query) {
		return OkC.get("/questions/search", {
			data: {
				query,
			},
		});
	},

	getQuestion(qid) {
		return OkC.get(`/questions/${qid}`);
	},

	getInterestMatches(params) {
		const data = {
			section: SECTIONS.interests,
			row_only: true,
			limit: USERS_TO_FETCH.interests || 20,
		};

		if (params.interest_text) {
			data.row_text = params.interest_text;
		} else {
			data.row_id = params.interest_id;
		}

		return OkC.post("/discovery/section", { data });
	},

	getQuestionMatches(questionId, selectedAnswers) {
		return OkC.post("/discovery/section", {
			data: {
				section: SECTIONS.important_questions,
				row_only: true,
				row_id: questionId,
				row_text: selectedAnswers
					? selectedAnswers.join(",")
					: undefined,
				limit: USERS_TO_FETCH.important_questions || 20,
			},
		});
	},
};



// WEBPACK FOOTER //
// ./src/apps/discovery/util/web.js